var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-secondary-info btn-micro resposta",on:{"click":function($event){$event.preventDefault();}}},[_vm._v(" N/A ")])])}
var staticRenderFns = []

export { render, staticRenderFns }